import React from "react";
import { Button } from "react-bootstrap";
import { dmReportList } from "../../data";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { reqToUpdateReportList } from "../../store/slice/reportSlice";

const DMPortal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleChangeCallType = (item) => {
    dispatch(reqToUpdateReportList([]));
    navigate(item?.route, {
      state: {
        ...item,
        title: item?.title,
        reportType: item?.value,
      },
    });
  };

  return (
    <div className="d-flex m-auto flex-column justify-content-center gap-3 min-width-300">
      {Array.isArray(dmReportList) &&
        dmReportList.map((item, i) => {
          if (item?.isActive) {
            return (
              <Button
                key={i}
                type="button"
                onClick={() => handleChangeCallType(item)}
              >
                {item.label}
              </Button>
            );
          } else {
            return null;
          }
        })}
    </div>
  );
};

export default DMPortal;
